const PersonalSkill = ({name}) => {
    return ( <div className='personal-skill'>
        {name}
    </div>);
}
 
export default PersonalSkill;